// extracted by css-extract-rspack-plugin
export default {"checkboxContainer":"checkboxContainer-2UbMT"};